// User action types
export const FETCH_USERS_REQUEST = 'users/FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'users/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'users/FETCH_USERS_FAILURE';
export const ADD_USER_SUCCESS = 'users/ADD_USER_SUCCESS';
export const UPDATE_USER_SUCCESS = 'users/UPDATE_USER_SUCCESS';
export const DELETE_USER_SUCCESS = 'users/DELETE_USER_SUCCESS';
export const SET_EDITING_USER = 'users/SET_EDITING_USER';
export const CLEAR_EDITING_USER = 'users/CLEAR_EDITING_USER';
